import { Button } from '@mui/material'
import { paymentModes } from '../common/paymentsMode'
import { findObjctByValueFromArrayOfObject } from '../common/helper'
import { companySettingsAtom, luggageSendOTP } from '../common/jotaiState/commonStateAtoms'
import { useAtom } from 'jotai'
import ReceipientOTPModel from '../content/DeliveryActivity/ReceipientOTPModel'
import { alertAtom, modalAtom } from '../common/jotaiState/globalStateAtoms'
import { useState } from 'react'

export const LrTrackCommonControls = (props) => {
  const { lrInfo, lrStatInfo = false, loginData, roleRights, data } = props
  const { Table = [], Table1 = [] } = roleRights
  const { BookingBranchID = -1, DestinationBranchID = -1, RecMobileNo, BookingID } = lrInfo || {}
  const [{ AllowReprint = 0, AllowAllBranchLRCancel = 0 } = {}] = Table1
  const branchUnatchBooking = AllowAllBranchLRCancel === 1 ? false : ![BookingBranchID, DestinationBranchID].includes(loginData.intBranchID)
  const branchUnatch = ![BookingBranchID, DestinationBranchID].includes(loginData.intBranchID)
  const bookingStatus = lrStatInfo ? lrStatInfo[lrStatInfo.length - 1].TYPE : false
  let key = paymentModes?.filter((val) => val.typeId == Number(lrInfo?.PaymentType))?.[0]?.roleRightsId
  const cancelBookingRights = findObjctByValueFromArrayOfObject(Table, 2, 'BookingRightsID')?.[0]
  const cancelDeliveryRights = findObjctByValueFromArrayOfObject(Table, 10, 'BookingRightsID')?.[0]
  const [companySettings] = useAtom(companySettingsAtom)
  const [, setAlert] = useAtom(alertAtom)
  const [model, setModal] = useAtom(modalAtom)
  const { IsLRRefundOTP = 0 } = companySettings
  const [userOTP, setUserOtp] = useState('')
  const [OTPRecipient, setOTPRecipient] = useState('')
  const recipientMobNo = RecMobileNo || ''
  const sendRecipientOTPRequest = async (isModelOpen = false) => {
    const obj = {
      StrEventType: 'Refund LR',
      intCompanyID: loginData.intCompanyID,
      intUserID: loginData.intUserID,
      // strContactNo: '',
      intBookingID: BookingID,
      intMode: 6,
      // strBookingIDs: '',
      intOTPToUserID: 0,
      // strRemarks: ''
    }
    try {
      const res = await luggageSendOTP(obj)
      if (res?.Status !== true) {
        setAlert({ show: true, msg: res.ErrMessage })
        return null
      }
      setOTPRecipient(decodeURIComponent(res.OTP))
      if (isModelOpen) {
        setModal({ open: true, id: 'receipient-otp-modal' })
      }
    } catch (err) {
      setAlert({ show: true, msg: err })
      return null
    }
  }
  return (
    <>
      <div className="lrt-card-row">
        <div className="" style={{ padding: '8px' }}>
          <Button
            className="select-lr-btn"
            variant="contained"
            color="error"
            style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
            disabled={bookingStatus !== 'B' || branchUnatchBooking || cancelBookingRights?.Allowed === 0 || cancelBookingRights[key] === 0}
            onClick={async () => {
              if (IsLRRefundOTP === 1) {
                sendRecipientOTPRequest(true)
              } else {
                data?.bookingCancel()
              }
            }}
          >
            Booking Cancel
          </Button>
        </div>
        <div className="" style={{ padding: '8px' }}>
          <Button
            className="select-lr-btn"
            variant="contained"
            color="error"
            style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
            disabled={bookingStatus !== 'F' || branchUnatch || cancelDeliveryRights?.Allowed === 0 || cancelDeliveryRights[key] === 0}
            onClick={data?.deliveryCancel}
          >
            Delivery Cancel
          </Button>
        </div>
      </div>
      <div className="lrt-card-row">
        <div className="input--wrapper" style={{ padding: '8px' }}>
          <Button
            // id={iid.searchLrButton}
            className="select-lr-btn"
            variant="contained"
            color="error"
            style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
            disabled={branchUnatch || AllowReprint === 0}
            onClick={data?.bookingReprint}
          >
            Booking Reprint
          </Button>
        </div>
        <div className="input--wrapper" style={{ padding: '8px' }}>
          <Button
            className="select-lr-btn"
            variant="contained"
            color="error"
            style={{ backgroundColor: '#fe5200', fontSize: '1.3rem', width: '100%' }}
            disabled={bookingStatus !== 'F' || branchUnatch || AllowReprint === 0}
            onClick={data?.deliveryReprint}
          >
            Delivery Reprint
          </Button>
        </div>
      </div>
      {(model.open && model.id === 'receipient-otp-modal') &&
        <ReceipientOTPModel
          OTP={OTPRecipient}
          userOTP={userOTP}
          setUserOtp={setUserOtp}
          recipientMobNo={recipientMobNo}
          sendOTPRequest={sendRecipientOTPRequest}
          showHeader={true}
          changeHeadingText={true}
          saveApi={(isVerified) => {
            if (isVerified) {
              setModal({ open: false, id: '' })
              setOTPRecipient('')
              data?.bookingCancel()
            }
          }}
        />
      }
    </>
  )
}